import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 25,
	height: 32,
	viewBox: "0 0 25 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 6C6.48605 6 2 10.4861 2 16C2 21.5139 6.48605 26 12 26C17.5139 26 22 21.5139 22 16C22 10.4861 17.5139 6 12 6ZM17.5429 13.9626L11.1563 20.3492C10.9619 20.5436 10.6925 20.6551 10.4177 20.6551V21.0876L10.4084 20.6551C10.1299 20.6528 9.85946 20.5364 9.66616 20.336L6.44411 16.9963C6.04411 16.5818 6.056 15.9196 6.47049 15.5196C6.66616 15.3306 6.92368 15.2268 7.19546 15.2268C7.48151 15.2268 7.74854 15.3401 7.94724 15.5459L10.4311 18.1204L16.0662 12.4856C16.2634 12.2884 16.5256 12.1797 16.8048 12.1797C17.0837 12.1797 17.3459 12.2882 17.5431 12.4854C17.9501 12.8928 17.9501 13.5555 17.5429 13.9626Z",
		fill: "#8895A7"
	})
});
export default SvgCheck;
